import React, { useState } from 'react';
import { PromptLibraryModal } from './PromptLibraryModal';
import { Button } from '../../../../ui/atoms/Button/Button';
const meta = {
    title: 'Features/AIChatWidget/PromptLibraryModal',
    component: PromptLibraryModal,
    parameters: {
        design: {
            type: 'figma',
            url: 'https://www.figma.com/embed?embed_host=storybook&url=https://www.figma.com/design/fucwkIpniyaRuGlJGCdTtK/Inspect-Point-AI?node-id=571-12281&chrome=NONE'
        }
    }
};
export default meta;
export const Default = {
    args: {
        isOpen: true,
        onClose: () => {
            console.log('Close prompt library');
        },
        onUsePrompt: (prompt) => {
            console.log('Use prompt:', prompt);
        }
    }
};
export const Closed = {
    args: {
        isOpen: false,
        onClose: () => {
            console.log('Close prompt library');
        },
        onUsePrompt: (prompt) => {
            console.log('Use prompt:', prompt);
        }
    }
};
function InteractiveWrapper() {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState(null);
    return (React.createElement("div", { style: { padding: 24 } },
        React.createElement(Button, { variant: "primary", onClick: () => setIsOpen(true) }, "Open Prompt Library"),
        selectedPrompt && (React.createElement("div", { style: { marginTop: 16, padding: 12, background: '#f5f5f5', borderRadius: 8 } },
            React.createElement("strong", null, "Selected prompt:"),
            React.createElement("p", null, selectedPrompt))),
        React.createElement(PromptLibraryModal, { isOpen: isOpen, onClose: () => setIsOpen(false), onUsePrompt: (prompt) => {
                setSelectedPrompt(prompt);
                setIsOpen(false);
            } })));
}
export const Interactive = {
    render: () => React.createElement(InteractiveWrapper, null)
};
